// tslint:disable:ordered-imports
import {FILTERS_SAVED, FiltersStateInterface } from "./../../store/actions/filters.actions";
import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { catchError, retry } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ProgramArticleService } from "../../services/program-article.service";
import { ProgramArticle } from "../../models/program-article";
import {
  ProgramArticlesActions,
  ProgramArticlesStateInterface,
} from "../../store/actions/program-articles.actions";
import { Store } from "@ngrx/store";
import { AdminService } from "../../services/admin.service";
import { Translation } from "../../models/translation";
import { MdDialog } from "@angular/material";
import { SuccessComponent } from "../../modals/success/success.component";
import { User } from "../../models/user";
import { Value } from "../../models/value";
import * as _ from "lodash";
import { EventArticleService } from "../../services/event-article.service";
import { TranslationService } from "../../services/translation.service";
import { SportingEventMetadatas } from "../../models/metadata/sporting-event-metadatas.model";
import { TransmissionMetadatas } from "../../models/metadata/transmission-metadatas.model";
import { EmissionMetadatas } from "../../models/metadata/emission-metadatas.model";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-program-article-details",
  templateUrl: "./program-article-details.component.html",
  styleUrls: ["./program-article-details.component.scss"],
})
export class ProgramArticleDetailsComponent implements OnDestroy {
  subscriptions: Subscription[];
  programArticleSubscription: Subscription;
  programArticle: ProgramArticle;
  initialProgramArticle: ProgramArticle;
  loading: boolean;
  loadingCommentator: boolean;
  currentUser: User;
  selectIndex = 0;
  filters: FiltersStateInterface;
  isSport = false;
  destinationsUser: Value[];
  territories: string;
  affiliates: string;
  websites: string;
  audios: string;
  externalEvents: string;
  masterSportingEventId: number;
  masterSportingEventName: string;
  masterSportingEventPicture: string;

  sportPicture: string;
  sportPictogram: string;
  eventPictogram: string;
  metadatas: EmissionMetadatas;

  /**
   * Load the program article form the params ID and set it as the current program article in the store
   * @param {ActivatedRoute} route
   * @param {ProgramArticlesActions} programArticlesActions
   * @param {Store<any>} store
   * @param {Router} router
   * @param {MdDialog} mdDialog
   * @param {AdminService} adminService
   * @param {ProgramArticleService} programArticleService
   */
  constructor(
    private route: ActivatedRoute,
    private programArticlesActions: ProgramArticlesActions,
    private store: Store<any>,
    private router: Router,
    private mdDialog: MdDialog,
    public adminService: AdminService,
    private programArticleService: ProgramArticleService,
    private translationService: TranslationService,
    private eventArticleService: EventArticleService
  ) {
    this.subscriptions = [];
    this.destinationsUser = [];
    this.metadatas = null;
    this.territories = "";
    this.affiliates = "";
    this.websites = "";
    this.audios = "";
    this.externalEvents = "";
    this.masterSportingEventName = "";
    this.masterSportingEventPicture = "";
    this.loadingCommentator = false;
    this.sportPicture = "";
    this.sportPictogram = "";
    this.eventPictogram = "";

    this.store
      .select("filtersState")
      .subscribe((filtersState: FiltersStateInterface) => {
        this.filters = filtersState;
        this.initTab();
      });

    // When picture of Sporting Event changed, refresh pictureUrl
    this.subscriptions.push(
      this.store.select("eventArticlesState").subscribe(() => {
        this.GetSportingEventPicture();
      })
    );

    // When picture or pictogram of Translation, refresh pictureUrl
    this.subscriptions.push(
      this.store.select("translationsState").subscribe(() => {
        this.GetSportAndEventPictures();
      })
    );
    this.loadProgram();
  }

  // Reviver to parse JSON Date from string
  dateTimeReviver = function (key, value) {
    if (
      typeof value === "string" &&
      /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/.test(value)
    ) {
      return new Date(value);
    }
    return value;
  };
  loadProgram() {
    this.destinationsUser = JSON.parse(
      localStorage.getItem("destinations")
    ).filter((destination) => destination.id != "AllDestinations");
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        if (params["valEmiId"]) {
          if (this.programArticleSubscription) {
            this.programArticleSubscription.unsubscribe();
          }
          this.loading = true;
          this.subscriptions.push(
            this.store.select("userState").subscribe((user: User) => {
              if (user) {
                this.sportPicture = "";
                this.currentUser = user;
                this.programArticleSubscription = this.programArticleService
                  .getProgramArticle(
                    params["valEmiId"],
                    params["channelId"],
                    params["languageId"],
                    params["cocoonId"]
                  )
                  .subscribe((programArticle) => {
                    if (
                      programArticle.destinations.find(
                        (d) =>
                          d.value.translations.filter(
                            (t) =>
                              t.language.id ===
                              this.currentUser.currentLanguage.id
                          ).length > 0
                      )
                    ) {
                      this.programArticlesActions.setCurrentProgramArticle(
                        programArticle
                      );

                      // TO DO JETIE-1969
                      // filtersActions NOT USED

                      // After setting current program article from URI, modify filters to match the program
                      // Get filters to compare. If program article date match the filters, don't modify
                      this.subscriptions.push(
                        this.store
                          .select("filtersState")
                          .subscribe((filters: FiltersStateInterface) => {
                            if (
                              (programArticle.broadcastDate <
                                filters.startDate ||
                                programArticle.broadcastDate >
                                  filters.endDate) &&
                              params["isSeeReplay"] == 0
                            ) {
                              var filterFromLocalStorage = JSON.parse(
                                localStorage.getItem(FILTERS_SAVED),
                                this.dateTimeReviver
                              );
                              if (filterFromLocalStorage != null) {
                                filters = filterFromLocalStorage;
                              }
                              filterFromLocalStorage.startDate =
                                programArticle.broadcastDate;
                              filterFromLocalStorage.endDate =
                                programArticle.broadcastDate;
                              localStorage.setItem(
                                FILTERS_SAVED,
                                JSON.stringify(filterFromLocalStorage)
                              );
                            }
                          })
                      );

                      if (
                        this.currentUser.currentLanguage.features.includes(
                          "DATA_DUPLICATE"
                        )
                      ) {
                        if (
                          this.programArticle.destinations.find(
                            (d) => d.id === "Press"
                          )
                        ) {
                          localStorage.setItem(
                            "initialPressDescriptionContent",
                            this.programArticle.destinations
                              .find((d) => d.id === "Press")
                              .value.translations.find(
                                (t) => t.fieldName === "Description"
                              ).content
                          );
                        }
                      }
                      if (
                        this.currentUser.currentLanguage.features.includes(
                          "DATA_DUPLICATE_PARTNERS"
                        )
                      ) {
                        if (
                          this.programArticle.destinations.find(
                            (d) => d.id === "Partners"
                          )
                        ) {
                          localStorage.setItem(
                            "initialPartnersDescriptionContent",
                            this.programArticle.destinations
                              .find((d) => d.id === "Partners")
                              .value.translations.find(
                                (t) => t.fieldName === "Description"
                              ).content
                          );
                        }
                      }

                      this.initTab();

                      // If emission has sporting event or transmission id, get metadatas
                      this.metadatas = new EmissionMetadatas({
                        affiliates: [],
                        audios: [],
                        cities: [],
                        countries: [],
                        externalEvents: [],
                        federations: [],
                        playersTeams: [],
                        rscs: [],
                        sponsors: [],
                        territories: [],
                        venues: [],
                        websites: [],
                      });

                      this.territories = "";
                      this.affiliates = "";
                      this.websites = "";
                      this.audios = "";
                      this.externalEvents = "";
                      if (this.programArticle.spev.id != 0) {
                        this.getSportingEventMetadatas();
                      }

                      if (this.programArticle.transmissionId != "") {
                        this.getTransmissionMetadatas();
                      }

                      this.masterSportingEventId = null;
                      this.masterSportingEventName = null;
                      this.masterSportingEventPicture = "";

                      // Get Master Sporting Event Infos (Id / Name / Picture)
                      if (this.programArticle.spev.id != 0) {
                        // Get Commentator
                        if (
                          this.programArticle &&
                          this.programArticle.isSport &&
                          this.programArticle.spev &&
                          this.programArticle.spev.value != "0"
                        ) {
                          this.loadingCommentator = true;
                          this.programArticleService
                            .getCommentator(
                              this.programArticle.spev.id,
                              this.programArticle.variant.id,
                              this.programArticle.language.value
                            )
                            .subscribe((result) => {
                              this.programArticle.commentator = result;
                              this.loadingCommentator = false;
                            });
                        }

                        this.programArticleService
                          .GetMasterSportingEventId(this.programArticle.spev.id)
                          .subscribe((result) => {
                            this.masterSportingEventId = result;
                            this.programArticleService
                              .GetSportingEvent(this.masterSportingEventId)
                              .subscribe((result) => {
                                this.masterSportingEventName = result.name;
                              });
                          });
                      }

                      this.loading = false;
                    } else {
                      this.router.navigate(["program-articles"]);
                    }
                  });
              } else {
                this.currentUser = null;
              }
            })
          );
        }
      })
    );

    this.store
      .select("programArticlesState")
      .subscribe((programArticleState: ProgramArticlesStateInterface) => {
        this.programArticle = programArticleState.currentProgramArticle;
        this.initialProgramArticle = _.cloneDeep(this.programArticle);
        this.initTab();
      });
  }

  getSportingEventMetadatas() {
    if (this.programArticle && this.programArticle.spev.id != 0) {
      // If SpevJ0 set, use it instead
      let sportingEventId = this.programArticle.spevJ0.id
        ? this.programArticle.spevJ0.id
        : this.programArticle.spev.id;
      this.programArticleService
        .GetSportingEventMetadatas(
          sportingEventId,
          this.programArticle.language.id
        )
        .subscribe((result: SportingEventMetadatas) => {
          this.metadatas.cities = result.cities;
          this.metadatas.countries = result.countries;
          this.metadatas.externalEvents = result.externalEvents;
          this.metadatas.federations = result.federations;
          this.metadatas.playersTeams = result.playersTeams;
          this.metadatas.sponsors = result.sponsors;
          this.metadatas.venues = result.venues;
          this.refreshTooltipMetadatas();
        });
    }
  }

  getTransmissionMetadatas() {
    this.programArticleService
      .getTransmissionMetadatas(
        this.programArticle.transmissionId,
        this.programArticle.language.id
      )
      .subscribe((result: TransmissionMetadatas) => {
        this.metadatas.affiliates = result.affiliates;
        this.metadatas.audios = result.audios.filter(
          (a) =>
            a.type != null &&
            (a.type.toLowerCase() === "confirmed" ||
              a.type.toLowerCase() === "native")
        );
        this.metadatas.cities = result.cities;
        this.metadatas.countries = result.countries;
        this.metadatas.externalEvents = result.externalEvents;
        this.metadatas.rscs = result.rscs;
        this.metadatas.sponsors = result.sponsors;
        this.metadatas.territories = result.territories;
        this.metadatas.venues = result.venues;
        this.metadatas.websites = result.websites;
        this.refreshTooltipMetadatas();
      });
  }

  refreshTooltipMetadatas() {
    this.territories = this.metadatas.territories
      .map((t) => t.value)
      .join(", ");

    this.affiliates = this.metadatas.affiliates.map((t) => t.value).join(", ");
    this.websites = this.metadatas.websites.map((t) => t.value).join(", ");
    this.audios = this.metadatas.audios.map((t) => t.value).join(", ");

    this.externalEvents = this.metadatas.externalEvents
      .map((t) => t.type + ": " + t.value + "(" + t.key + ")")
      .join(", ");
  }

  initTab() {
    if (
      this.programArticle &&
      this.programArticle.destinations &&
      this.filters
    ) {
      this.programArticle.destinations.forEach((allProgramDest) => {
        const destTokeep = this.destinationsUser.find(
          (d) => d.value === allProgramDest.id
        );
        if (!destTokeep) {
          this.programArticle.destinations =
            this.programArticle.destinations.filter(
              (t) => t.id !== allProgramDest.id
            );
        }
      });
      const destination = this.programArticle.destinations.find(
        (d) => d.id === this.filters.defaultDestination
      );
      if (destination) {
        this.selectIndex =
          this.programArticle.destinations.indexOf(destination);
      }

      if (this.programArticle.destinations.find((d) => d.id === "Popup Next")) {
        let isLocked =
          this.programArticle.destinations.find((d) => d.id === "Popup Next")
            .value.pictures[0] &&
          this.programArticle.destinations.find((d) => d.id === "Popup Next")
            .value.pictures[0].isLocked;

        if (!isLocked) {
          if (
            this.programArticle.destinations.find((t) => t.id === "Digital")
          ) {
            this.programArticle.destinations.find(
              (t) => t.id === "Popup Next"
            ).value.pictures = _.cloneDeep(
              this.programArticle.destinations
                .find((t) => t.id === "Digital")
                .value.pictures.filter(
                  (p) =>
                    p.pictureFormatName == "Original" ||
                    p.pictureFormatName == "16:9"
                )
            );
          }
        }
      }
    }
  }

  /**
   * On destroy, unsubscribe all the subscriptions and clear the current program article value in the store
   */
  ngOnDestroy() {
    this.sportPicture = "";
    // Check if programArticleSubscription exists to avoid javascript exception
    if (this.programArticleSubscription) {
      this.programArticleSubscription.unsubscribe();
    }
    this.subscriptions.map((sub) => sub.unsubscribe());
    this.programArticlesActions.setCurrentProgramArticle(null);
  }

  getInflowURL(broadcastId: string) {
    return environment.inflowURL + "program/esp-" + broadcastId;
  }

  saveProgramOnly() {
    this.saveFields(false);
  }

  saveProgramAndReplays() {
    this.saveFields(true);
  }

  // Get Sporting Event Picture
  GetSportingEventPicture() {
    if (
      this.programArticle &&
      this.masterSportingEventId > 0 &&
      this.masterSportingEventPicture == ""
    ) {
      this.eventArticleService
        .GetPictures(
          this.masterSportingEventId,
          this.programArticle.language.id
        )
        .subscribe((pictures) => {
          if (pictures.length > 0) {
            this.masterSportingEventPicture = pictures.find(
              (picture) => picture.pictureFormatCode === "16:9"
            ).pictureURL;
          } else {
            this.masterSportingEventPicture = null;
          }
        });
    }
  }

  GetSportAndEventPictures() {
    if (
      this.programArticle &&
      this.programArticle.isSport &&
      this.sportPicture == ""
    ) {
      // Get Sport and Event picture
      this.translationService
        .getTranslationById(
          this.programArticle.sport.id,
          "2",
          this.programArticle.language.id
        )
        .subscribe((result) => {
          this.sportPicture = result.pictures.find(
            (picture) => picture.pictureFormatCode === "Original"
          ).pictureURL;

          this.sportPictogram = result.pictogram.pictureURL;
        });

      this.translationService
        .getTranslationById(
          this.programArticle.event.id,
          "4",
          this.programArticle.language.id
        )
        .subscribe((result) => {
          this.eventPictogram = result.pictogram.pictureURL;
        });
    }
  }

  saveFields(saveReplays: boolean) {
    console.log("saveFields");
    this.loading = true;

    if (this.programArticle.pictureModified) {
      console.log("this.programArticle.pictureModified");
      console.log("saving", this.programArticle);

      this.programArticleService.updatePictures(this.programArticle, saveReplays)
        .pipe(
          retry(2),
          catchError((error) => {
            this.loading = false;
            this.handleError(error);
            return of(null); // Return a safe value or empty observable
          })
        )
        .subscribe((res) => {
          if (res && res.value && res.value.destinations) {
            console.log("res", res);
            console.log("destinations", this.programArticle.destinations);
            // update pictures
            this.programArticle.destinations.forEach((destination) => {
              console.log("destination", destination);
              const pic = res.value.destinations.find(
                (d) => d.id === destination.id
              ).value.pictures;
              console.log("pic", pic);
              if (pic) {
                destination.value.pictures = pic;
              }
            });
            this.saveProgramArticle(saveReplays);
          } else {
            this.loading = false;
          }
        });
    } else {
      this.saveProgramArticle(saveReplays);
    }
  }

  saveProgramArticle(saveReplays: boolean) {
    const isProgramArticleResponse = (response: any): response is { programArticle: ProgramArticle, programArticles?: any[]} =>
      response['programArticle'] !== undefined

    this.programArticleService.updateProgramArticle(this.programArticle, saveReplays, true)
      .pipe(
        retry(2),
        catchError((error) => {
          this.loading = false;
          this.handleError(error);
          return of(null); // Return a safe value or empty observable
        })
      )
      .subscribe((data) => {
        if (data && isProgramArticleResponse(data)) {
          this.programArticlesActions.updateProgramArticle(data.programArticle);
          this.programArticlesActions.setCurrentProgramArticle(data.programArticle);
          if (data.programArticles) {
            this.programArticlesActions.updateProgramArticles(data.programArticles);
          }
          this.loading = false;
          this.mdDialog.open(SuccessComponent, {
            data: { message: "This program has been updated" },
          });
        } else {
          this.loading = false;
        }
      });
  }


  private handleError(error: any) {
    console.error("An error occurred", error);
    let message = "An error occurred. Please try again later.";

    if (error.status === 0) {
      message = "Network error. Please check your internet connection.";
    } else if (error.status >= 500) {
      message = "Server error. Please try again later.";
    } else if (error.name === 'TimeoutError') {
      message = "Request timed out. Please try again.";
    }

    this.mdDialog.open(SuccessComponent, {
      data: { message: message, type: "error" },
    });
  }


  /**
   * Open the picture edition modal to edit the program article picture
   * @param {string} type
   * @param {Translation} translation
   */
  editPicture(type: string, translation: Translation) {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "edit",
            "picture",
            this.programArticle.id,
            translation.id,
            type,
            "program-article",
          ],
        },
      },
    ]);
  }

  /**
   * Open the modal that shows all the replays
   */
  seeReplays() {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "view",
            "replays",
            this.programArticle.spev.id,
            this.programArticle.contentId,
            this.currentUser.currentLanguage.id,
            this.programArticle.destinations[this.selectIndex].id,
            this.programArticle.btSportProductCode
              ? this.programArticle.btSportProductCode
              : "0",
            this.programArticle.programId,
          ],
        },
      },
    ]);
  }

  /**
   * Open the modal that shows all the related MultiCams
   */
  seeMultiCams() {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "view",
            "multicams",
            this.programArticle.spev.id,
            this.currentUser.currentLanguage.id,
            this.programArticle.destinations[this.selectIndex].id,
          ],
        },
      },
    ]);
  }

  /**
   * Open the modal that shows all the additional pictures
   */
  seeAdditionalPictures() {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "view",
            "additional",
            this.programArticle.valEmiId,
            this.programArticle.channel.id,
            this.currentUser.currentLanguage.id,
            this.programArticle.destinations[this.selectIndex].id,
          ],
        },
      },
    ]);
  }

  /**
   * Duplicate the Digital tab data to Partners
   */
  duplicateDigitalDataToPartners() {
    let partnersTranslations = this.programArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.translations;

    let digitalTranslations = this.programArticle.destinations.find(
      (t) => t.id === "Digital"
    ).value.translations;

    partnersTranslations.find(
      (t) =>
        t.name === "Title" && t.language.id === this.programArticle.language.id
    ).content =
      digitalTranslations
        .find(
          (t) =>
            t.name === "Title" &&
            t.language.id === this.programArticle.language.id
        )
        .content.trim() +
      " " +
      digitalTranslations
        .find(
          (t) =>
            t.name === "Feature" &&
            t.language.id === this.programArticle.language.id
        )
        .content.trim();

    // Lock title
    partnersTranslations.find(
      (t) =>
        t.name === "Title" && t.language.id === this.programArticle.language.id
    ).isLocked = true;

    partnersTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).content = digitalTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).content;

    partnersTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).isLocked = true;

    this.programArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.pictures = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === "Digital").value
        .pictures
    );

    // Lock pictures
    this.programArticle.destinations
      .find((t) => t.id === "Partners")
      .value.pictures.forEach((p) => (p.isLocked = true));

    // For each picture copied, set PictureModified to true
    this.programArticle.destinations
      .find((t) => t.id === "Partners")
      .value.pictures.forEach((p) => (p.modified = true));
    this.programArticle.pictureModified = true;
  }

  /**
   * Duplicate the Digital tab data to Press
   */
  duplicateData() {
    let pressTranslations = this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.translations;

    let digitalTranslations = this.programArticle.destinations.find(
      (t) => t.id === "Digital"
    ).value.translations;

    pressTranslations.find(
      (t) =>
        t.name === "Title" && t.language.id === this.programArticle.language.id
    ).content = digitalTranslations.find(
      (t) =>
        t.name === "Title" && t.language.id === this.programArticle.language.id
    ).content;

    pressTranslations.find(
      (t) =>
        t.name === "Feature" &&
        t.language.id === this.programArticle.language.id
    ).content = digitalTranslations.find(
      (t) =>
        t.name === "Feature" &&
        t.language.id === this.programArticle.language.id
    ).content;

    pressTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).content = digitalTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).content;

    pressTranslations.find(
      (t) =>
        t.name === "Title" && t.language.id === this.programArticle.language.id
    ).isLocked = true;
    pressTranslations.find(
      (t) =>
        t.name === "Feature" &&
        t.language.id === this.programArticle.language.id
    ).isLocked = true;
    pressTranslations.find(
      (t) =>
        t.name === "Description" &&
        t.language.id === this.programArticle.language.id
    ).isLocked = true;

    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.pictures = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === "Digital").value
        .pictures
    );

    // For each picture copied, set PictureModified to true
    this.programArticle.destinations
      .find((t) => t.id === "Press")
      .value.pictures.forEach((p) => (p.modified = true));
    this.programArticle.pictureModified = true;
  }

  /**
   * Initial Press data
   */
  initialData() {
    let translations = this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.translations;
    let initialTranslations = this.initialProgramArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.translations;

    translations.find((t) => t.name === "Title").content =
      initialTranslations.find((t) => t.name === "Title").content;
    translations.find((t) => t.name === "Feature").content =
      initialTranslations.find((t) => t.name === "Feature").content;
    translations.find((t) => t.name === "Description").content =
      initialTranslations.find((t) => t.name === "Description").content;

    translations.find((t) => t.name === "Title").isLocked =
      initialTranslations.find((t) => t.name === "Title").isLocked;
    translations.find((t) => t.name === "Feature").isLocked =
      initialTranslations.find((t) => t.name === "Feature").isLocked;
    translations.find((t) => t.name === "Description").isLocked =
      initialTranslations.find((t) => t.name === "Description").isLocked;

    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.pictures = this.initialProgramArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.pictures;
    this.programArticle.pictureModified =
      this.initialProgramArticle.pictureModified;
  }

  /**
   * Initial Partners data
   */
  initialPartnersData() {
    let translations = this.programArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.translations;
    let initialTranslations = this.initialProgramArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.translations;

    translations.find((t) => t.name === "Title").content =
      initialTranslations.find((t) => t.name === "Title").content;
    translations.find((t) => t.name === "Feature").content =
      initialTranslations.find((t) => t.name === "Feature").content;
    translations.find((t) => t.name === "Description").content =
      initialTranslations.find((t) => t.name === "Description").content;

    translations.find((t) => t.name === "Title").isLocked =
      initialTranslations.find((t) => t.name === "Title").isLocked;
    translations.find((t) => t.name === "Feature").isLocked =
      initialTranslations.find((t) => t.name === "Feature").isLocked;
    translations.find((t) => t.name === "Description").isLocked =
      initialTranslations.find((t) => t.name === "Description").isLocked;

    this.programArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.pictures = this.initialProgramArticle.destinations.find(
      (t) => t.id === "Partners"
    ).value.pictures;
    this.programArticle.pictureModified =
      this.initialProgramArticle.pictureModified;
  }

  /**
   * Duplicate the Language into INTER Language
   */
  duplicateInter(destinationName: any) {
    // Delete first to replace them
    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.translations = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.filter((t) => t.language.id !== 0);

    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.pictures = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.pictures.filter((p) => p.language.id !== 0);

    let translations = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === destinationName)
        .value.translations
    );
    translations.forEach((t) => (t.language.id = 0));
    translations.forEach((t) => (t.language.value = "INTERNATIONAL"));
    translations.forEach((t) => (t.programFieldId = 0));

    let pictures = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === destinationName)
        .value.pictures
    );
    pictures.forEach((t) => (t.language.id = 0));
    pictures.forEach((t) => (t.language.value = "INTERNATIONAL"));
    pictures.forEach((p) => (p.modified = true));

    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.translations = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.concat(translations);

    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.pictures = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.pictures.concat(pictures);
  }

  /**
   * Duplicate the Language into INTER Language
   */
  duplicatePressInter() {
    // Delete first to replace them
    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.translations = this.programArticle.destinations
      .find((t) => t.id === "Press")
      .value.translations.filter((t) => t.language.id !== 0);

    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.pictures = this.programArticle.destinations
      .find((t) => t.id === "Press")
      .value.pictures.filter((p) => p.language.id !== 0);

    let translations = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === "Digital").value
        .translations
    );
    translations.forEach((t) => (t.language.id = 0));
    translations.forEach((t) => (t.language.value = "INTERNATIONAL"));
    translations.forEach((t) => (t.programFieldId = 0));

    let pictures = _.cloneDeep(
      this.programArticle.destinations.find((t) => t.id === "Digital").value
        .pictures
    );
    pictures.forEach((t) => (t.language.id = 0));
    pictures.forEach((t) => (t.language.value = "INTERNATIONAL"));
    pictures.forEach((p) => (p.modified = true));

    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.translations = this.programArticle.destinations
      .find((t) => t.id === "Press")
      .value.translations.concat(translations);

    this.programArticle.destinations.find(
      (t) => t.id === "Press"
    ).value.pictures = this.programArticle.destinations
      .find((t) => t.id === "Press")
      .value.pictures.concat(pictures);
  }

  /**
   * Upon untoggled, remove Inter data
   */
  deleteDataInter(destinationName: any) {
    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.translations = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.filter((t) => t.language.id != 0);
    this.programArticle.destinations.find(
      (t) => t.id === destinationName
    ).value.pictures = this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.pictures.filter((t) => t.language.id != 0);
  }

  /**
   * Open the edit picture modal for event article
   */
  editSportPicture() {
    if (this.adminService.can("Translate", "Edit")) {
      this.router.navigate([
        {
          outlets: {
            modal: [
              "edit",
              "picture",
              this.programArticle.sport.id,
              "2",
              "Original",
              "translate",
            ],
          },
        },
      ]);
    }
  }

  /**
   * Open the edit picture modal for event article
   */
  editElementPictogram(elementId: string, typeId: string) {
    if (this.adminService.can("Translate", "Edit")) {
      this.router.navigate([
        {
          outlets: {
            modal: [
              "edit",
              "pictogram",
              elementId,
              typeId,
              "Pictogram",
              "translate",
            ],
          },
        },
      ]);
    }
  }

  /**
   * Open the edit picture modal for event article
   */
  editEventArticlePicture() {
    if (this.adminService.can("Event Article", "Edit")) {
      this.router.navigate([
        {
          outlets: {
            modal: [
              "edit",
              "picture",
              this.masterSportingEventId,
              0,
              "Original",
              "event-article",
            ],
          },
        },
      ]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/program-article-details/program-article-details.component.ts